import { render } from "./Kaidian.vue?vue&type=template&id=b736ca42&scoped=true"
import script from "./Kaidian.vue?vue&type=script&lang=js"
export * from "./Kaidian.vue?vue&type=script&lang=js"

import "./Kaidian.vue?vue&type=style&index=0&id=b736ca42&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b736ca42"]])

export default __exports__